import i18n from "i18next"
import { initReactI18next } from "react-i18next"

import cardiacEn from "./locales/en/cardiac.json"
import commonEn from "./locales/en/common.json"
import homeEn from "./locales/en/home.json"
import layoutEn from "./locales/en/layout.json"
import moodEn from "./locales/en/mood.json"
import patientEn from "./locales/en/patient.json"
import phq9En from "./locales/en/phq9.json"
import physicalActivityEn from "./locales/en/physicalActivity.json"
import sleepEn from "./locales/en/sleep.json"
import thresholdsEn from "./locales/en/thresholds.json"
import userEn from "./locales/en/user.json"
import medicationEn from "./locales/en/medication.json"

import cardiacDe from "./locales/de/cardiac.json"
import commonDe from "./locales/de/common.json"
import homeDe from "./locales/de/home.json"
import layoutDe from "./locales/de/layout.json"
import moodDe from "./locales/de/mood.json"
import patientDe from "./locales/de/patient.json"
import phq9De from "./locales/de/phq9.json"
import physicalActivityDe from "./locales/de/physicalActivity.json"
import sleepDe from "./locales/de/sleep.json"
import thresholdsDe from "./locales/de/thresholds.json"
import userDe from "./locales/de/user.json"
import medicationDe from "./locales/de/medication.json"

const resources = {
    en: {
        cardiac: cardiacEn,
        common: commonEn,
        home: homeEn,
        layout: layoutEn,
        mood: moodEn,
        patient: patientEn,
        phq9: phq9En,
        physicalActivity: physicalActivityEn,
        sleep: sleepEn,
        thresholds: thresholdsEn,
        user: userEn,
        medication: medicationEn
    },
    de: {
        cardiac: cardiacDe,
        common: commonDe,
        home: homeDe,
        layout: layoutDe,
        mood: moodDe,
        patient: patientDe,
        phq9: phq9De,
        physicalActivity: physicalActivityDe,
        sleep: sleepDe,
        thresholds: thresholdsDe,
        user: userDe,
        medication: medicationDe
    }
}

i18n.use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        lng: "de",
        interpolation: {
            escapeValue: false // react already safes from xss
        }
    })
export default i18n
